import { render, staticRenderFns } from "./FormButtons.vue?vue&type=template&id=5a179dc5&"
import script from "./FormButtons.js?vue&type=script&lang=js&"
export * from "./FormButtons.js?vue&type=script&lang=js&"
import style0 from "./FormButtons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports